import { CapacityCard } from "./CapacityCard";
import { CompanyForm } from "./CompanyForm";
import { CompanyList } from "./CompanyList";
import { FeatureAdoption } from "./FeatureAdoption";
import { FeatureRequests } from "./FeatureRequests";
import { PlatformStats } from "./PlatformStats";
import { SignupRequests } from "./SignupRequests";

// تبويبات: نظرة عامة · الشركات · الميزات · طلبات التسجيل — القسم الأول من لوحة المالك.
export const PlatformPanelsA = ({ tab, state, adding, setAdding, reload, can }) => {
  if (tab === "overview")
    return (
      <div className="grid gap-8">
        <PlatformStats stats={state.stats} />
        {can("system") ? <CapacityCard /> : null}
      </div>
    );

  if (tab === "companies")
    return (
      <div className="grid gap-6">
        {adding ? (
          <CompanyForm
            onCancel={() => setAdding(false)}
            onSaved={() => {
              setAdding(false);
              reload();
            }}
          />
        ) : null}
        <CompanyList companies={state.companies} reload={reload} />
      </div>
    );

  if (tab === "requests") return <SignupRequests requests={state.requests} reload={reload} />;

  return (
    <div className="grid gap-6">
      <FeatureAdoption />
      <FeatureRequests />
    </div>
  );
};
